/**
 * Reloads the current URL — the "Try again" of a route rendered as an error
 * card (TO-640 http-error-pages REQ-003). A module seam so tests can observe it;
 * jsdom's `location.reload` cannot be spied on directly.
 */
export function reloadPage(): void {
	window.location.reload()
}
